<template>
  <div class="performance-goals">
    <div class="box-view">
      <el-button size="small" :type="currentView === 'table' ? 'primary' : 'default'" @click="currentView = 'table'">业绩设置</el-button>
      <el-button v-if="canViewChart" size="small" :type="currentView === 'summary' ? 'primary' : 'default'" @click="currentView = 'summary'">业绩图表</el-button>
    </div>
    <br>

    <template v-if="currentView === 'table'">
      <Table
        v-if="users.length"
        :users="users"
        :disabled="!canEdit"
      />
    </template>

    <Summary v-if="currentView === 'summary'" :users="users" />
  </div>
</template>

<script>
import { Vue, Component, Mixins } from 'vue-property-decorator';
import Utils from '@/components/utils.vue';
import Table from './table.vue';
import Summary from './summary.vue';
import { abilityService } from 'beans-admin-plugin';

@Component({
  components: {
    Table,
    Summary,
  },
  props: {
    users: {
      type: Array,
      default: () => []
    }
  }
})
export default class WeekPerformanceGoals extends Mixins(Vue, Utils) {
  currentView = 'table'; // table

  get canViewChart() {
    return abilityService.can(['reports/sales_follows.read']);
  }

  get canEdit() {
    return abilityService.can(['performance_goals.update', 'performance_goals.create']);
  }
}
</script>

<style lang="scss" scoped>
.performance-goals {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
